import poslovneJediniceImg from "../../../../../picture/poslovne-jedinice.png";
import { useEffect, useState } from "react";
import PrikazListe from "./PrikazListe";
import Dodavanje from "./Dodavanje";

const dataMock = {
  // POSLOVNE_JEDINICE: [
  //   { id: "1", naziv: "POSLOVNA JEDINICA 1" },
  //   { id: "2", naziv: "POSLOVNA JEDINICA 2" }
  // ],
  // GRADILISTA: [{ id: "3", tip: "GRADILISTE", naziv: "GRADILISTE SMEDEREVO" }],
  RADILISTA: []
};

function ShowBarPoslovneJedinice() {
  const [data, setData] = useState([]);
  const [isDodaj, setIsDodaj] = useState(false);

  useEffect(() => {
    if (dataMock) setData(dataMock);
  }, [dataMock]);

  return (
    <div
      style={{
        backgroundColor: "white",
        display: "flex",
        flexDirection: "column"
      }}
    >
      <div
        style={{
          width: "100%",
          display: "flex",
          justifyContent: "center",
          padding: "10px"
        }}
      >
        <img src={poslovneJediniceImg} style={{ width: "40%" }} />
      </div>
      {isDodaj ? (
        <Dodavanje setData={setData} setIsDodaj={setIsDodaj} />
      ) : (
        <PrikazListe data={data} setIsDodaj={setIsDodaj} ex />
      )}
    </div>
  );
}

export default ShowBarPoslovneJedinice;
